export const GA_ACTIONS = {
    MIGRATION: "Migration",
    CLICK: "Click",
    SLIDE: "Slide",
    COMPLETED: "Completed",
    ERROR: "Error",
    AUTHENTICATE: "Authenticate",
    VIEW: "View",           // ScreenView
    STATUS_SHOWN: "StatusShown"
}
export const PRODUCT_TYPE = {
    SMART_MONEY : "DL_SMARTMONEY"
}